import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';
import md5 from 'md5';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const userService = {
    login,
    logout,
    getAll,
    getById,
    create,
    update,
    remove,
    registerUser,
    loginUser,
    logoutUser,
    updateUserDetails,
    getUserDetails,
    getCustomers,
    getCountries,
    updateCustomer
};

function login(email, password, remember) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ email, password, remember })
    };

    return fetch(Config.api.basepath+`/auth/signin`, requestOptions)
        .then(handleResponse)
        .then(
            user => {
                if (user) {
                    user.authdata = window.btoa(email + ':' + password);
                    localStorage.setItem('user', JSON.stringify(user));
                }

                return user;
            },
            error => {
                // return {error: 'Login Error. Service Unavailable.'};
                 return {error: error}
            }
        );
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function create(body) {
    const newUser = body;

    const emailHash = md5(body.email.toLowerCase());
    body.avatar = 'https://www.gravatar.com/avatar/'+emailHash+'?s=50&d=identicon&r=PG'

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(newUser)
    };

    return fetch(Config.api.basepath+`/auth/signup`, requestOptions).then(handleResponse);
}

function update(body) {
    // const newUser = {
    //     firstName: body.editUserFirstName,
    //     lastName: body.editUserLastName,
    //     team: body.editUserTeam
    // };
    const id = body._id;
    delete body._id;

    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/user/`+id, requestOptions).then(handleResponse);
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/user?`;

        url = options.page ? url + `page=` + options.page : url
        url = options.items ? url + `&per-page=` + options.items : url
        url = options.limit ? url + `&limit=` + options.limit : url;
    
        let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
            return r.concat(k + ':' + options.filter[k]);
        }, []);
    
        url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            users => {
                let pages = parseInt(users.total / users['per-page']);
                pages = users.total > ( pages * users['per-page'] ) ? pages + 1 : pages;

                users.pages = pages;

                return users;
            },
            error => {
                return {error: 'Fetch users Error. Service Unavailable.'};
            }
        );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/user/`+id, requestOptions)
        .then(handleResponse)
        .then(
            user => {
                return user;
            },
            error => logout()
        );
}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/user/`+id, requestOptions).then(handleResponse);
}



function registerUser(data) {
    const baseUrl = window.location.origin;
    const registerEndpoint = `${baseUrl}/wp-json/custom/v1/register`;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    };

    return fetch(registerEndpoint, requestOptions)
        .then(response => {
            if (!response.ok) {
                // Handle non-OK responses
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error(errorData.message || 'Failed to register user: Unknown error');
                });
            }
            return response.json();
        })
        .catch(error => {
            // Handle network errors or other exceptions
            console.error('Error registering user:', error);
            throw new Error('Failed to register user: ' + error.message || 'Unknown error');
        });
}


function loginUser(username, password, remember) {
    const baseUrl = window.location.origin;

    const credentials = {
        username: username,
        password: password,
        remember: remember
    };

    return fetch(`${baseUrl}/wp-json/custom/v1/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
    .then(response => {
        // Check if the response status is not OK (e.g., 403 for unverified email)
        if (!response.ok) {
            return response.json().then(data => {
                // Return the error message from the server
                throw new Error(data.message || 'Login failed. Please try again.');
            });
        }
        return response.json(); // Proceed if response is OK
    })
    .then(data => {
        console.log('Login Response:', data); // Debugging log

        if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));

            console.log('Stored Token:', localStorage.getItem('token')); // Debugging log

            if (data.user.role === 'administrator') {
                window.location.href = `${baseUrl}/wp-admin/`;
            } else {
                return { success: true, user: data.user };
            }
        } else {
            return { success: false, error: 'Invalid credentials' };
        }
    })
    .catch(error => {
        console.error('Login Error:', error.message);
        return { success: false, error: error.message };
    });
}


function logoutUser() {
    const baseUrl = window.location.origin;

    return fetch(`${baseUrl}/wp-json/custom/v1/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
        if (data.message) {
            // Clear the nonce from localStorage (or any other secure storage)
            localStorage.removeItem('token');
            localStorage.removeItem('user', JSON.stringify(data.user));
            return { success: true };
        } else {
            return { success: false, error: 'Logout failed. Please try again.' };
        }
    })
    .catch(error => {
        console.error(error);
        return { success: false, error: 'Logout failed. Please try again.' };
    });
}

function getUserDetails(userId) {
    const baseUrl = window.location.origin;

    return fetch(`${baseUrl}/wp-json/myplugin/v1/woocommerce-billing-address/${userId}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch user details');
            }
            return response.json();
        })
        .then(data => {
            console.log('User details:', data); // Check the entire response here
            return data;
        })
        .catch(error => {
            console.error('Error fetching user details:', error);
            throw new Error('Failed to fetch user details');
        });
}

function updateUserDetails(userId, updatedDetails) {
    const baseUrl = window.location.origin;

    return fetch(`${baseUrl}/wp-json/myplugin/v1/update-user-details/${userId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedDetails)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to update user details');
        }
        return response.json();
    })
    .then(data => {
        return data;
    })
    .catch(error => {
        console.error('Error updating user details:', error);
        throw new Error('Failed to update user details');
    });
}


function getCustomers(customerId) {
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/wp-json/wc/v3/customers/${customerId}`;

    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };

    return fetch(url, requestConfig)
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch customer details');
        }
        return response.json();
    })
    .then(customerData => {
        // Extract the billing information from the customer data
        const billingInfo = customerData;
        //console.log('Billing information:', customerData);
        return billingInfo;
    })
    .catch(error => {
        console.error('Error fetching customer details:', error);
        throw new Error('Failed to fetch customer details');
    });
}


function getCountries() {
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/wp-json/wc/v3/data/countries`;

    const requestConfig = {
        method: 'GET',
        headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
    };

    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch countries');
            }
            return response.json();
        })
        .then(countryData => {
            //console.log('Countries:', countryData);
            return countryData;
        })
        .catch(error => {
            console.error('Error fetching countries:', error);
            throw new Error('Failed to fetch countries');
        });
}

function updateCustomer(customerId, updatedData) {

    console.log(updatedData)
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/wp-json/wc/v3/customers/${customerId}`;
    const oauth = oauthFunction();

    const requestConfig = {
        method: 'PUT', // or 'PUT' depending on your API
        headers: {
            'Content-Type': 'application/json',
            ...oauth.toHeader(oauth.authorize({ url, method: 'PUT' }))
        },
        body: JSON.stringify(updatedData) // Include the updated customer data here
    };

    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to update customer details');
            }
            return response.json();
        })
        .then(updatedCustomerData => {
            console.log('Updated customer details:', updatedCustomerData);
            //localStorage.removeItem('user', JSON.stringify(data.user));
            return updatedCustomerData;
        })
        .catch(error => {
            console.error('Error updating customer details:', error);
            throw new Error('Failed to update customer details');
        });
}

function oauthFunction() {
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });
    return oauth;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.failed) ||(data && data.error.errmsg) ||(data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
